module.exports = __webpack_public_path__ + "img/btn_menu_all_c.f1f77768.png";